import { render, staticRenderFns } from "./LegacyImportButton.vue?vue&type=template&id=79b04bc5&scoped=true"
import script from "./LegacyImportButton.vue?vue&type=script&lang=js"
export * from "./LegacyImportButton.vue?vue&type=script&lang=js"
import style0 from "./LegacyImportButton.vue?vue&type=style&index=0&id=79b04bc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b04bc5",
  null
  
)

export default component.exports